var path = 'src/app/patients/metadata/metadata.html';
var html = "<h1 class=page-header>Metadata</h1> <div patient-metadata-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/metadata/metadata.html
 ** module id = 416
 ** module chunks = 0
 **/